import React from "react";
import { motion } from "framer-motion";
import './corner.css';
import { projExitBgDelay, projExitBgDuration, projExitBgEase } from "../../pages/Archive/variables";


const CornerComponent = ({size, wrappingRoom, displayIndex, bcWrapperRef, tlRef, trRef, blRef, brRef, isPresent, isProjectExit, bgCornersActive, performInitial, triggerExit, isExitingFullscreen, customTransition=null}) => {

    const topSVGCorrectorVariants = {
        shallow: {
            transform: "translate3d(100%, 0px, 0)"
        }, deep:{
            transform: "translate3d(100%, -2px, 0)"
        }
    }

    const bottomRightConnectors = {
        shallow: {
            transform: "translate(100%,-1px)"
        }, deep: {
            transform: "translate(100%,-3px)"
        }
    }

    const bottomLeftCorrectors = {
        shallow: {
            transform: `translate3d(100%, 0px, 0) scaleY(1)`
        }, deep: {
            transform: "translate3d(100%, -1px, 0) scaleY(1)"
        }
    }

    const trSideCornerVariant = {
        shallow: {
            d: "M0.5 41C0.5 41 0.507528 18.5001 0.505722 0.037319",
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1]
            }
            
        }, deep: {
            d: "M3.50001 42.0002C3.50001 42.0002 3 19.5 0.498761 1.03694",
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1]
            }
        }, projExit:{
            d: "M0.5 41C0.5 41 0.507528 18.5001 0.505722 0.037319",
            transition: {
                duration: projExitBgDuration,
                delay: projExitBgDelay,
                ease: projExitBgEase
            }
        }
    }

    const tlUpperVariant = {
        shallow: {
            d: "M0.972656 41C0.972656 41 0.971368 19 0.971368 1.8946e-05"
        }, deep: {
            d: "M1 42C1 42 0.5 20.5 1.98309 1.00002"
        }
    }

        
    const trUpperCornerVariant = {
        shallow: {
            d: "M1 0.499512C1 0.499512 0.998052 17 0.998808 40.0003",
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1]
            }
        },
        deep: {
            
            d: "M2 0.5C2 0.5 2 18 0.998808 40.0003",
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1]
            }
        }, 
        projExit: {
            d: "M1 0.499512C1 0.499512 0.998052 17 0.998808 40.0003",
            transition: {
                duration: 1,
                ease: [0.87, 0, 0.13, 1]
            }
        }
    }

    const cornerVariants = {
        initial:{
            transform: performInitial ? "scale(0)" : "scale(1)"
        },animate:{
            transform: "scale(1)",
            transition: {
                delay: performInitial ? !isExitingFullscreen ? 0.25 : 0.7 : 0.7,
                duration: 3,
                ease: [0.16, 1, 0.3, 1]
            }
        },exit:{
            transform: "scale(0)",
            transition: {
                duration: 1,
                ease: [0.16, 1, 0.3, 1] 
            }
        }
    }

    return(
        <div 
            className={`bc_wrapper`}
            id="archive_corner_wrapper"
            ref={bcWrapperRef}
            style={{
                width: `calc(100% + ${wrappingRoom}px)`,
                height: `calc(100% + ${wrappingRoom}px)`,
                left: `${-wrappingRoom/2}px`,
                top: `${-wrappingRoom/2}px`,
                zIndex: displayIndex,
                transition: customTransition ? customTransition : ""
            }}
        >
            <div className="left">
                <div 
                    className="t" 
                    ref={tlRef}
                    style={{
                        width: size,
                        height: size
                    }}
                >
                    <motion.div className="corner_scaler"
                        style={{
                            transformOrigin: "top left"
                        }}
                        initial="initial"
                        animate={triggerExit ? "exit" : "animate"}
                        exit="exit"
                        variants={cornerVariants}
                    >
                        <div
                            style={{
                                position: "absolute",
                                top: "0",
                                right: "0",
                                display: "flex",
                                transform: "rotate(90deg) scaleX(-1) translate3d(calc(100% - 2px), 1px, 0)"
                            }}    
                        >
                            <svg 
                            xmlns="http://www.w3.org/2000/svg" width="2" height="39" viewBox="0 0 2 39" fill="none">
                                <motion.path 
                                    initial="shallow"
                                    animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                    exit="shallow"
                                    stroke="var(--light-color)"
                                    variants={trUpperCornerVariant}  
                                />
                            </svg>
                        </div>
                        <div 
                            style={{
                                transform: "scaleY(-1) rotate(180deg)"
                            }}
                        >
                            <motion.svg 
                                className="bent"
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                }}
                                initial="shallow"
                                animate={bgCornersActive && isPresent ? "deep" : "shallow"}
                                exit="shallow"
                                variants={topSVGCorrectorVariants}
                                xmlns="http://www.w3.org/2000/svg" width="5" height="43" viewBox="0 0 5 43" fill="none">
                                <motion.path 
                                    initial="shallow"
                                    animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                    exit="shallow" stroke="var(--light-color)"
                                    variants={trSideCornerVariant}    
                                />
                            </motion.svg>
                        </div>
                    </motion.div>
                </div>
                <div className="b" ref={blRef} style={{
                        width: size,
                        height: size
                    }}>
                    <motion.div
                        className="corner_scaler"
                        style={{
                            transformOrigin: "bottom left",
                            height: size,
                            width: size
                        }}
                        initial="initial"
animate={triggerExit ? "exit" : "animate"}
exit="exit"
variants={cornerVariants}
                    >
                        <div
                            style={{
                                position: "absolute",
                                top: "0",
                                right: "0",
                                display: "flex",
                                transform: "rotate(270deg) scaleX(-1) scaleY(-1) translate3d(100%, 1px, 0)"
                            }}    
                            >
                        <svg 
                        xmlns="http://www.w3.org/2000/svg" width="2" height="39" viewBox="0 0 2 39" fill="none">
                            <motion.path 
                                initial="shallow"
                                animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                exit="shallow"
                                stroke="var(--light-color)"
                                variants={trUpperCornerVariant}  
                            />
                        </svg>
                        </div>
                        <div 
                            style={{
                                transform: "scaleY(-1) scaleX(-1) translateY(-1px)",
                                width: size,
                                height: size,
                                position: "absolute"
                            }}
                        >
                            <motion.svg 
                                className="bent"
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    transform: `translate3d(100%, -1px, 0)`
                                }}
                                initial="initial"
                                animate={bgCornersActive && isPresent ? "deep" : "shallow"}
                                exit="shallow"
                                variants={bottomLeftCorrectors}
                                xmlns="http://www.w3.org/2000/svg" width="5" height="43" viewBox="0 0 5 43" fill="none">
                                <motion.path 
                                    initial="shallow"
                                    animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                    exit="shallow" 
                                    stroke="var(--light-color)"
                                    variants={trSideCornerVariant}
                                />
                            </motion.svg>
                        </div>
                    </motion.div>

                </div>
            </div>
            <div className="right">
                <div 
                    className="t"
                    ref={trRef}
                    style={{
                        width: `${size}px`,
                        height: `${size}px`
                    }}
                    
                >
                    <motion.div
                        className="corner_scaler"
                        style={{
                            transformOrigin: "top right",
                            height: size,
                            width: size
                        }}
                        initial="initial"
animate={triggerExit ? "exit" : "animate"}
exit="exit"
variants={cornerVariants}> 
                            <motion.svg 
                                className="bent"
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    right: 0
                                }}
                                initial="shallow"
                                animate={bgCornersActive && isPresent ? "deep" : "shallow"}
                                exit="shallow"
                                variants={topSVGCorrectorVariants}
                                xmlns="http://www.w3.org/2000/svg" width="5" height="43" viewBox="0 0 5 43" fill="none">
                                <motion.path 
                                    initial="shallow"
                                    animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                    exit="shallow" stroke="var(--light-color)"
                                    variants={trSideCornerVariant}    
                                />
                            </motion.svg>
                            <div
                                style={{
                                    display: "flex",
                                    transform: "rotate(270deg) translate3d(calc(100% - 2px), 1px, 0)"
                                }}    
                            >
                                <svg 
                                xmlns="http://www.w3.org/2000/svg" width="2" height="39" viewBox="0 0 2 39" fill="none">
                                    <motion.path 
                                        initial="shallow"
                                        animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                        exit="shallow"
                                        stroke="var(--light-color)"
                                        variants={trUpperCornerVariant}  
                                    />
                                </svg>
                            </div>
                    </motion.div>
                </div>
                <div className="b" ref={brRef} style={{
                        width: size,
                        height: size
                    }}>
                    <motion.div
                        className="corner_scaler"
                        style={{
                            transformOrigin: "bottom right",
                            height: size,
                            width: size
                        }}
                        initial="initial"
                        animate={triggerExit ? "exit" : "animate"}
                        exit="exit"
                        variants={cornerVariants}> 
                            <div
                                style={{
                                    position: "absolute",
                                    display: "flex",
                                    left: 0,
                                    transform: "rotate(90deg) scaleY(-1) translate3d(100%, 1px, 0)"
                                }}    
                            >
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" width="2" height="39" viewBox="0 0 2 39" fill="none">
                                    <motion.path 
                                        initial="shallow"
                                        animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                        exit="shallow"
                                        stroke="var(--light-color)"
                                        variants={trUpperCornerVariant}  
                                    />
                                </svg>
                            </div>
                            <div 
                                style={{
                                    transform: "scaleY(1) scaleX(-1) rotate(180deg) ",
                                    width: size,
                                    height: size,
                                    position: "absolute"
                                }}
                            >
                                <motion.svg 
                                    className="bent"
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        right: 0,
                                    }}
                                    initial="shallow"
                                    animate={bgCornersActive && isPresent ? "deep" : "shallow"}
                                    exit="shallow"
                                    variants={bottomRightConnectors}
                                    xmlns="http://www.w3.org/2000/svg" width="5" height="43" viewBox="0 0 5 43" fill="none">
                                    <motion.path 
                                        initial="shallow"
                                        animate={!isPresent && isProjectExit ? "projExit" : bgCornersActive ? "deep" : "shallow"}
                                        exit="shallow" stroke="var(--light-color)"
                                        variants={trSideCornerVariant}    
                                    />
                                </motion.svg>
                            </div>
                    </motion.div>
                </div>
            </div>
        </div>
    )
}

export default CornerComponent;